import React from "react";
import { Container, Spinner } from "react-bootstrap";

type Props = {};

const LoadingIndicator: React.FC<Props> = (props: Props) => {
	return (
		<Container
			className="d-flex align-items-center justify-content-center"
			style={{ height: "100%" }}
		>
			<Spinner animation="grow" variant="primary" />
		</Container>
	);
};

export default LoadingIndicator;
